import { render, staticRenderFns } from "./SortTable.vue?vue&type=template&id=3cac2c2b&scoped=true"
import script from "./SortTable.vue?vue&type=script&lang=js"
export * from "./SortTable.vue?vue&type=script&lang=js"
import style0 from "./SortTable.vue?vue&type=style&index=0&id=3cac2c2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac2c2b",
  null
  
)

export default component.exports